import { noop } from 'lodash'
import { useState } from 'react'

export interface UseDisclosureProps {
  initialIsOpen?: boolean
  onClose?: () => void
  onOpen?: () => void
  onToggle?: () => void
}

/**
 * Hook to handle disclosure state for a dialog
 */
export const useDisclosure = ({
  initialIsOpen = false,
  onClose = noop,
  onOpen = noop,
}: UseDisclosureProps = {}) => {
  const [open, setOpen] = useState(initialIsOpen)

  const handleOpen = () => {
    setOpen(true)
    onOpen()
  }
  const handleClose = () => {
    setOpen(false)
    onClose()
  }

  const handleToggle = () => {
    setOpen((isOpen) => !isOpen)
  }

  return {
    isOpen: open,
    open: handleOpen,
    close: handleClose,
    toggle: handleToggle,
  }
}
